import { useEffect } from "react";
import { useQueries } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import PageHeading from "../components/PageHeading";
import Card from "../components/Card";
import CardLoader from "../components/CardLoader";
import useLocalStorage from "../hooks/useLocalStorage";

const FollowedArtists = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [followedArtistIds, setFollowedArtistIds] = useLocalStorage(
    "followed_artists",
    []
  );

  useEffect(() => {
    const handleFollowedArtistsUpdate = () => {
      try {
        const stored = localStorage.getItem("followed_artists");
        const parsed = stored ? JSON.parse(stored) : [];
        setFollowedArtistIds(Array.isArray(parsed) ? parsed : []);
      } catch (error) {
        setFollowedArtistIds([]);
      }
    };

    window.addEventListener(
      "followed_artists_updated",
      handleFollowedArtistsUpdate
    );
    return () => {
      window.removeEventListener(
        "followed_artists_updated",
        handleFollowedArtistsUpdate
      );
    };
  }, [setFollowedArtistIds]);

  const followedArtistQueries = useQueries({
    queries: followedArtistIds.map((artistId) => ({
      queryKey: [`api/artists/${artistId}`],
      enabled: !!artistId,
    })),
  });

  const followedArtists = followedArtistQueries
    .map((query) => query?.data?.data)
    .filter(Boolean);
  const isFollowedArtistsLoading =
    followedArtistIds.length > 0 &&
    followedArtistQueries.some((query) => query.isLoading || query.isFetching);

  return (
    <Layout seo={{ title: "Followed Artists | Azzir Events", noindex: true }}>
      <PageHeading title="Followed Artists" />
      <section className="hero fillter-sec section-gap wow fadeInUp" data-wow-delay="0.2s">
        <div className="container">
          <div className="club-result-row section-gap-btm wow fadeInUp" data-wow-delay="0.2s">
            <div className="container">
              <div className="card-list">
                <div className="row">
                  {isFollowedArtistsLoading ? (
                    <>
                      <CardLoader />
                      <CardLoader />
                      <CardLoader />
                    </>
                  ) : followedArtists?.length ? (
                    followedArtists.map((followedArtist, index) => (
                      <Card
                        key={followedArtist?._id || index.toString()}
                        artist={followedArtist}
                        index={index}
                      />
                    ))
                  ) : (
                    <div className="col-12">
                      <p className="no-data-found">No followed artists yet</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Link to="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </Link>
    </Layout>
  );
};

export default FollowedArtists;
